/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/test-drive'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import TestDrives from '@routes/TestDrives';

export const Route = createFileRoute('/test-drive/')({
  component: () => <CacheDataRoute component={TestDrives} path='/test-drive' />
});
